let breedOptions = [
  'Mixed / Other...',
  'Affenpinscher',
  'Afghan Hound',
  'Africanis',
  'Aidi',
  'Airedale Terrier',
  'Akbash',
  'Akita',
  'Aksaray Malaklisi',
  'Alano Español',
  'Alapaha Blue Blood Bulldog',
  'Alaskan husky',
  'Alaskan Klee Kai',
  'Alaskan Malamute',
  'Alopekis',
  'Alpine Dachsbracke',
  'American Bulldog',
  'American Bully',
  'American Cocker Spaniel',
  'American English Coonhound',
  'American Eskimo Dog',
  'American Foxhound',
  'American Hairless Terrier',
  'American Pit Bull Terrier',
  'American Staffordshire Terrier',
  'American Water Spaniel',
  'Andalusian Hound',
  'Anglo-Français de Petite Vénerie',
  'Appenzeller Sennenhund',
  'Ariegeois',
  'Armant',
  'Armenian Gampr dog',
  'Artois Hound',
  'Australian Cattle Dog',
  'Australian Kelpie',
  'Australian Shepherd',
  'Australian Stumpy Tail Cattle Dog',
  'Australian Terrier',
  'Austrian Black and Tan Hound',
  'Austrian Pinscher',
  'Azawakh',
  'Bakharwal dog',
  'Banjara Hound',
  'Barbado da Terceira',
  'Barbet',
  'Basenji',
  'Basque Shepherd Dog',
  'Basset Artésien Normand',
  'Basset Bleu de Gascogne',
  'Basset Fauve de Bretagne',
  'Basset Hound',
  'Bavarian Mountain Hound',
  'Beagle',
  'Beagle-Harrier',
  'Belgian Shepherd',
  'Bearded Collie',
  'Beauceron',
  'Bedlington Terrier',
  'Bergamasco Shepherd',
  'Berger Picard',
  'Bernese Mountain Dog',
  'Bichon Frisé',
  'Billy',
  'Black and Tan Coonhound',
  'Black Norwegian Elkhound',
  'Black Russian Terrier',
  'Black Mouth Cur',
  'Bloodhound',
  'Blue Lacy',
  'Blue Picardy Spaniel',
  'Bluetick Coonhound',
  'Boerboel',
  'Bohemian Shepherd',
  'Bolognese',
  'Border Collie',
  'Border Terrier',
  'Borzoi',
  'Bosnian Coarse-haired Hound',
  'Boston Terrier',
  'Bouvier des Ardennes',
  'Bouvier des Flandres',
  'Boxer',
  'Boykin Spaniel',
  'Bracco Italiano',
  "Braque d'Auvergne",
  "Braque de l'Ariège",
  'Braque du Bourbonnais',
  'Braque Francais',
  'Braque Saint-Germain',
  'Briard',
  'Briquet Griffon Vendéen',
  'Brittany',
  'Broholmer',
  'Bruno Jura Hound',
  'Brussels Griffon',
  'Bucovina Shepherd Dog',
  'Bull Arab',
  'Bull Terrier',
  'Bulldog',
  'Bullmastiff',
  'Bully Kutta',
  'Burgos Pointer',
  'Ca Mè Mallorquí',
  'Cairn Terrier',
  'Ca Mè Mallorquí',
  'Campeiro Bulldog',
  'Can de Chira',
  'Can de Palleiro',
  'Canaan Dog',
  'Canadian Eskimo Dog',
  'Cane Corso',
  'Cane di Oropa',
  'Cane Paratore',
  'Cantabrian Water Dog',
  'Cão da Serra de Aires',
  'Cão de Castro Laboreiro',
  'Cão de Gado Transmontano',
  'Cão Fila de São Miguel',
  'Cardigan Welsh Corgi',
  'Carea Castellano Manchego',
  'Carea Leonés',
  'Carolina Dog',
  'Carpathian Shepherd Dog',
  'Catahoula Leopard Dog',
  'Catalan Sheepdog',
  'Caucasian Shepherd Dog',
  'Cavalier King Charles Spaniel',
  'Central Asian Shepherd Dog',
  'Cesky Fousek',
  'Cesky Terrier',
  'Chesapeake Bay Retriever',
  'Chien Français Blanc et Noir',
  'Chien Français Blanc et Orange',
  'Chien Français Tricolore',
  'Chihuahua',
  'Chilean Terrier',
  'Chinese Crested Dog',
  'Chinook',
  'Chippiparai',
  'Chongqing dog',
  'Chortai',
  'Chow Chow',
  'Cimarrón Uruguayo',
  "Cirneco dell'Etna",
  'Clumber Spaniel',
  'Colombian fino hound',
  'Coton de Tulear',
  'Cretan Hound',
  'Croatian Sheepdog',
  'Curly-Coated Retriever',
  'Cursinu',
  'Czechoslovakian Wolfdog',
  'Dachshund',
  'Dalmatian',
  'Dandie Dinmont Terrier',
  'Danish Spitz',
  'Danish-Swedish Farmdog',
  'Denmark Feist',
  'Dingo',
  'Doberman Pinscher',
  'Dogo Argentino',
  'Dogo Guatemalteco',
  'Dogo Sardesco',
  'Dogue Brasileiro',
  'Dogue de Bordeaux',
  'Drentse Patrijshond',
  'Drever',
  'Dunker',
  'Dutch Shepherd',
  'Dutch Smoushond',
  'East Siberian Laika',
  'East European Shepherd',
  'Ecuadorian Hairless Dog',
  'English Cocker Spaniel',
  'English Foxhound',
  'English Mastiff',
  'English Setter',
  'English Shepherd',
  'English Springer Spaniel',
  'English Toy Terrier (Black & Tan)',
  'Entlebucher Mountain Dog',
  'Estonian Hound',
  'Estrela Mountain Dog',
  'Eurasier',
  'Field Spaniel',
  'Fila Brasileiro',
  'Finnish Hound',
  'Finnish Lapphund',
  'Finnish Spitz',
  'Flat-Coated Retriever',
  'French Bulldog',
  'French Spaniel',
  'Galgo Español',
  'Garafian Shepherd',
  'Gascon Saintongeois',
  'Georgian Shepherd',
  'German Hound',
  'German Longhaired Pointer',
  'German Pinscher',
  'German Roughhaired Pointer',
  'German Shepherd Dog',
  'German Shorthaired Pointer',
  'German Spaniel',
  'German Spitz',
  'German Wirehaired Pointer',
  'Giant Schnauzer',
  'Glen of Imaal Terrier',
  'Golden Retriever',
  'Gończy Polski',
  'Gordon Setter',
  'Grand Anglo-Français Blanc et Noir',
  'Grand Anglo-Français Blanc et Orange',
  'Grand Anglo-Français Tricolore',
  'Grand Basset Griffon Vendéen',
  'Grand Bleu de Gascogne',
  'Grand Griffon Vendéen',
  'Great Dane',
  'Greater Swiss Mountain Dog',
  'Greek Harehound',
  'Greek Shepherd',
  'Greenland Dog',
  'Greyhound',
  'Griffon Bleu de Gascogne',
  'Griffon Fauve de Bretagne',
  'Griffon Nivernais',
  'Gull Dong',
  'Gull Terrier',
  'Hällefors Elkhound',
  'Halden Hound',
  'Hamiltonstövare',
  'Hanover Hound',
  'Harrier',
  'Havanese',
  'Himalayan Sheepdog',
  'Hierran Wolfdog',
  'Hokkaido',
  'Hovawart',
  'Huntaway',
  'Hygen Hound',
  'Ibizan Hound',
  'Icelandic Sheepdog',
  'Indian pariah dog',
  'Indian Spitz',
  'Irish Red and White Setter',
  'Irish Setter',
  'Irish Terrier',
  'Irish Water Spaniel',
  'Irish Wolfhound',
  'Istrian Coarse-haired Hound',
  'Istrian Shorthaired Hound',
  'Italian Greyhound',
  'Jack Russell Terrier',
  'Jagdterrier',
  'Japanese Chin',
  'Japanese Spitz',
  'Japanese Terrier',
  'Jindo',
  'Jonangi',
  'Kai Ken',
  'Kaikadi',
  'Kangal Shepherd Dog',
  'Kanni',
  'Karakachan dog',
  'Karelian Bear Dog',
  'Kars',
  'Karst Shepherd',
  'Keeshond',
  'Kerry Beagle',
  'Kerry Blue Terrier',
  'Khala',
  'King Charles Spaniel',
  'King Shepherd',
  'Kintamani',
  'Kishu',
  'Kokoni',
  'Kombai',
  'Komondor',
  'Kooikerhondje',
  'Koolie',
  'Koyun dog',
  'Kromfohrländer',
  'Kuchi',
  'Kuvasz',
  'Labrador Retriever',
  'Lagotto Romagnolo',
  'Lakeland Terrier',
  'Lancashire Heeler',
  'Landseer',
  'Lapponian Herder',
  'Large Münsterländer',
  'Leonberger',
  'Levriero Sardo',
  'Lhasa Apso',
  'Lithuanian Hound',
  'Löwchen',
  'Lupo Italiano',
  'Mackenzie River husky',
  'Magyar agár',
  'Mahratta Greyhound',
  'Maltese',
  'Manchester Terrier',
  'Maneto',
  'Maremmano-Abruzzese Sheepdog',
  'McNab dog',
  'Miniature American Shepherd',
  'Miniature Bull Terrier',
  'Miniature Fox Terrier',
  'Miniature Pinscher',
  'Miniature Schnauzer',
  'Molossus of Epirus',
  'Montenegrin Mountain Hound',
  'Mountain Cur',
  'Mountain Feist',
  'Mucuchies',
  'Mudhol Hound',
  'Mudi',
  'Neapolitan Mastiff',
  'New Guinea singing dog',
  'New Zealand Heading Dog',
  'Newfoundland',
  'Norfolk Terrier',
  'Norrbottenspets',
  'Northern Inuit Dog',
  'Norwegian Buhund',
  'Norwegian Elkhound',
  'Norwegian Lundehund',
  'Norwich Terrier',
  'Nova Scotia Duck Tolling Retriever',
  'Old Croatian Sighthound',
  'Old Danish Pointer',
  'Old English Sheepdog',
  'Old English Terrier',
  'Olde English Bulldogge',
  'Otterhound',
  'Pachon Navarro',
  'Pampas Deerhound',
  'Paisley Terrier',
  'Papillon',
  'Parson Russell Terrier',
  'Pastore della Lessinia e del Lagorai',
  'Patagonian Sheepdog',
  'Patterdale Terrier',
  'Pekingese',
  'Pembroke Welsh Corgi',
  'Perro Majorero',
  'Perro de Pastor Mallorquin',
  'Perro de Presa Canario',
  'Perro de Presa Mallorquin',
  'Peruvian Inca Orchid',
  'Petit Basset Griffon Vendéen',
  'Polish Greyhound',
  'Polish Hound',
  'Polish Lowland Sheepdog',
  'Polish Tatra Sheepdog',
  'Pomeranian',
  'Pont-Audemer Spaniel',
  'Poodle',
  'Porcelaine',
  'Portuguese Podengo',
  'Portuguese Pointer',
  'Portuguese Water Dog',
  'Posavac Hound',
  'Pražský Krysařík',
  'Pshdar dog',
  'Pudelpointer',
  'Petit Bleu de Gascogne',
  'Phalène',
  'Pharaoh Hound',
  'Phu Quoc Ridgeback',
  'Picardy Spaniel',
  'Plummer Terrier',
  'Plott Hound',
  'Podenco Canario',
  'Podenco Valenciano',
  'Pointer',
  'Poitevin',
  'Pug',
  'Puli',
  'Pumi',
  'Pungsan dog',
  'Pyrenean Mastiff',
  'Pyrenean Mountain Dog',
  'Pyrenean Sheepdog',
  'Rafeiro do Alentejo',
  'Rajapalayam',
  'Rampur Greyhound',
  'Rat Terrier',
  'Ratonero Bodeguero Andaluz',
  'Ratonero Mallorquin',
  'Ratonero Murciano',
  'Ratonero Valenciano',
  'Redbone Coonhound',
  'Rhodesian Ridgeback',
  'Romanian Mioritic Shepherd Dog',
  'Romanian Raven Shepherd Dog',
  'Rottweiler',
  'Rough Collie',
  'Russian Spaniel',
  'Russian Toy',
  'Russo-European Laika',
  'Ryukyu Inu',
  'Saarloos Wolfdog',
  'Sabueso Español',
  'Saint Bernard',
  'Saint Hubert Jura Hound',
  'Saint-Usuge Spaniel',
  'Saluki',
  'Samoyed',
  'Sapsali',
  'Sarabi dog',
  'Sardinian Shepherd Dog',
  'Šarplaninac',
  'Schapendoes',
  'Schillerstövare',
  'Schipperke',
  'Schweizer Laufhund',
  'Schweizerischer Niederlaufhund',
  'Scottish Deerhound',
  'Scottish Terrier',
  'Sealyham Terrier',
  "Segugio dell'Appennino",
  'Segugio Italiano',
  'Segugio Maremmano',
  'Serbian Hound',
  'Serbian Tricolour Hound',
  'Serrano Bulldog',
  'Shar Pei',
  'Shetland Sheepdog',
  'Shiba Inu',
  'Shih Tzu',
  'Shikoku',
  'Shiloh Shepherd',
  'Siberian Husky',
  'Silken Windhound',
  'Silky Terrier',
  'Sinhala Hound',
  'Skye Terrier',
  'Sloughi',
  'Slovakian Wirehaired Pointer',
  'Slovenský Cuvac',
  'Slovenský Kopov',
  'Smalandstövare',
  'Small Greek domestic dog',
  'Small Münsterländer',
  'Smooth Collie',
  'Smooth Fox Terrier',
  'Soft-Coated Wheaten Terrier',
  'South Russian Ovcharka',
  'Spanish Mastiff',
  'Spanish Water Dog',
  'Spinone Italiano',
  'Sporting Lucas Terrier',
  'Stabyhoun',
  'Staffordshire Bull Terrier',
  'Standard Schnauzer',
  'Stephens Stock',
  'Styrian Coarse-haired Hound',
  'Sussex Spaniel',
  'Swedish Elkhound',
  'Swedish Lapphund',
  'Swedish Vallhund',
  'Swedish White Elkhound',
  'Taigan',
  'Taiwan Dog',
  'Tamaskan Dog',
  'Tazy',
  'Teddy Roosevelt Terrier',
  'Telomian',
  'Tenterfield Terrier',
  'Terrier Brasileiro',
  'Thai Bangkaew Dog',
  'Thai Ridgeback',
  'Tibetan Kyi Apso',
  'Tibetan Mastiff',
  'Tibetan Spaniel',
  'Tibetan Terrier',
  'Torkuz',
  'Tornjak',
  'Tosa',
  'Toy Fox Terrier',
  'Toy Manchester Terrier',
  'Transylvanian Hound',
  'Treeing Cur',
  'Treeing Feist',
  'Treeing Tennessee Brindle',
  'Treeing Walker Coonhound',
  'Trigg Hound',
  'Tyrolean Hound',
  'Vikhan',
  'Villano de Las Encartaciones',
  'Villanuco de Las Encartaciones',
  'Vizsla',
  'Volpino Italiano',
  'Weimaraner',
  'Welsh Sheepdog',
  'Welsh Springer Spaniel',
  'Welsh Terrier',
  'West Country Harrier',
  'West Highland White Terrier',
  'West Siberian Laika',
  'Westphalian Dachsbracke',
  'Wetterhoun',
  'Whippet',
  'White Shepherd',
  'White Swiss Shepherd Dog',
  'Wire Fox Terrier',
  'Wirehaired Pointing Griffon',
  'Wirehaired Vizsla',
  'Xiasi Dog',
  'Xoloitzcuintle',
  'Yakutian Laika',
  'Yorkshire Terrier',
  'Zerdava'
];

function initBreedDropdown() {
  // Get all search-wrap containers
  const searchWrappers = document.querySelectorAll('.search-wrap');

  searchWrappers.forEach((wrapper, wrapperIndex) => {
    // Get the original input
    const originalInput = wrapper.querySelector('.search-input');
    if (!originalInput) return;

    // Create the custom select container with proper classes
    const customSelect = document.createElement('div');
    customSelect.className = 'custom-select relative w-full';
    customSelect.id = `dog-breed-${wrapperIndex}-container`;

    // Create the display element (what looks like a select)
    const selectDisplay = document.createElement('div');
    selectDisplay.className =
      'select-display text-input w-full py-2 px-4 !bg-white rounded-lg shadow-none text-base cursor-pointer flex justify-between items-center';
    selectDisplay.setAttribute('data-value', '');
    selectDisplay.setAttribute('role', 'button');
    selectDisplay.setAttribute('aria-haspopup', 'listbox');
    selectDisplay.setAttribute('aria-expanded', 'false');

    // Create proper text span for display
    const selectText = document.createElement('span');
    selectText.className =
      'select-text truncate font-dmsan font-bold uppercase text-base';
    selectText.textContent = "Select your dog's breed";
    selectDisplay.appendChild(selectText);

    // Create dropdown arrow as SVG (matching the Liquid version)
    const arrow = document.createElement('span');
    arrow.className = 'select-arrow absolute right-4';
    arrow.innerHTML = `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path d="M16.25 7.5L10 13.75L3.75 7.5" stroke="currentColor" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    selectDisplay.appendChild(arrow);

    // Create the options container
    const optionsContainer = document.createElement('div');
    optionsContainer.className =
      'select-options absolute hidden left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-50 max-h-60 overflow-y-auto';
    optionsContainer.setAttribute('role', 'listbox');

    // Create search input for filtering options
    const searchFilter = document.createElement('div');
    searchFilter.className = 'px-3 py-2 border-b border-gray-200';

    const searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className =
      'select-search w-full p-2 text-sm border border-gray-300 rounded-md outline-core-forest [.flavor-color-blue_&]:outline-blue-dark [.flavor-color-orange_&]:outline-orange-dark';
    searchInput.placeholder = 'Search...';
    searchFilter.appendChild(searchInput);
    optionsContainer.appendChild(searchFilter);

    // Create options list
    const optionsList = document.createElement('ul');
    optionsList.className = 'select-list py-1';

    // Add all breed options
    breedOptions.forEach((breed, index) => {
      const option = document.createElement('li');
      option.className =
        'select-option px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm';
      option.textContent = breed;
      option.setAttribute('data-value', breed);
      option.setAttribute('role', 'option');

      option.addEventListener('click', function () {
        const value = this.getAttribute('data-value');

        // Clear any existing text content first
        selectDisplay.textContent = '';

        // Recreate the text span
        const updatedSelectText = document.createElement('span');
        updatedSelectText.className =
          'select-text truncate font-dmsan font-bold uppercase text-base';
        updatedSelectText.textContent = value;
        selectDisplay.appendChild(updatedSelectText);

        // Recreate the arrow
        const updatedArrow = document.createElement('span');
        updatedArrow.className = 'select-arrow absolute right-4';
        updatedArrow.innerHTML = `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path d="M16.25 7.5L10 13.75L3.75 7.5" stroke="currentColor" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `;
        selectDisplay.appendChild(updatedArrow);

        selectDisplay.setAttribute('data-value', value);
        optionsContainer.classList.add('hidden');
        selectDisplay.setAttribute('aria-expanded', 'false');

        // Set value in hidden input
        hiddenInput.value = value;

        // Needed for compatibility with existing code
        customSelect.classList.add('pet-breed-input');

        // Remove error message if showing
        const errorMsg = wrapper.querySelector('.add-error-message');
        if (errorMsg) errorMsg.classList.add('hidden');

        // Trigger a change event
        const event = new Event('change', { bubbles: true });
        hiddenInput.dispatchEvent(event);
      });

      optionsList.appendChild(option);
    });

    optionsContainer.appendChild(optionsList);

    // Create hidden input to store the selected value
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'radio';
    hiddenInput.id = `dog-breed-${wrapperIndex}`;
    hiddenInput.name = originalInput.name || 'pet-breed';
    hiddenInput.className = 'select-value pet-breed-value visually-hidden';
    hiddenInput.value = '';

    // Add event listeners
    selectDisplay.addEventListener('click', function (e) {
      e.stopPropagation();

      // Close all other open dropdowns
      document
        .querySelectorAll('.select-options:not(.hidden)')
        .forEach((dropdown) => {
          if (dropdown !== optionsContainer) {
            dropdown.classList.add('hidden');
            dropdown
              .closest('.custom-select')
              .querySelector('.select-display')
              .setAttribute('aria-expanded', 'false');
          }
        });

      // Toggle this dropdown
      optionsContainer.classList.toggle('hidden');
      this.setAttribute(
        'aria-expanded',
        optionsContainer.classList.contains('hidden') ? 'false' : 'true'
      );

      // Focus search if available and dropdown is open
      if (!optionsContainer.classList.contains('hidden')) {
        setTimeout(() => searchInput.focus(), 10);
      }
    });

    searchInput.addEventListener('input', function (e) {
      e.stopPropagation();
      const query = this.value.toLowerCase().trim();

      optionsList.querySelectorAll('.select-option').forEach((option) => {
        const text = option.textContent.toLowerCase();
        option.style.display = text.includes(query) ? '' : 'none';
      });
    });

    searchInput.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    document.addEventListener('click', function () {
      optionsContainer.classList.add('hidden');
      selectDisplay.setAttribute('aria-expanded', 'false');
    });

    optionsContainer.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // Assemble the custom select
    customSelect.appendChild(selectDisplay);
    customSelect.appendChild(optionsContainer);
    customSelect.appendChild(hiddenInput);

    // Add error message (corresponding to the one in the Liquid template)
    const errorMessage = wrapper.querySelector('.add-error-message');
    if (errorMessage) {
      errorMessage.className = 'error-message text-red-500 text-xs mt-1 hidden';
    }

    originalInput.parentNode.replaceChild(customSelect, originalInput);

    if (breedOptions.length > 0) {
      const firstValue = breedOptions[0];
      hiddenInput.value = firstValue;

      selectDisplay.innerHTML = '';

      const displayText = document.createElement('span');
      displayText.className =
        'select-text truncate font-dmsan font-bold uppercase text-base';
      displayText.textContent = firstValue;
      selectDisplay.appendChild(displayText);

      const displayArrow = document.createElement('span');
      displayArrow.className = 'select-arrow absolute right-4';
      displayArrow.innerHTML = `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path d="M16.25 7.5L10 13.75L3.75 7.5" stroke="currentColor" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
      selectDisplay.appendChild(displayArrow);

      selectDisplay.setAttribute('data-value', firstValue);

      hiddenInput.addEventListener('input', () => {
        const selectedOption = Array.from(optionsList.childNodes).find(
          (option) => option.dataset.value === hiddenInput.value
        );

        if (selectedOption) selectedOption.dispatchEvent(new Event('click'));
      });
    }
    return;
  });
}

const html = document.querySelector('html');
const selectModal = document.querySelector('.dog-info-modal');
const modalContentWrapper = selectModal.closest('[data-modal-content]');
const deleteConfirmPanel = selectModal.querySelector('#delete-confirm-panel');
let selectedCount;

// PDP Hidden inputs
let namePropInput = document.getElementById('ip--dog-name');

// Find all modal open triggers and construct array for event listener
let openTriggers = [];
let nameTrigger = document.getElementById('name-trigger');
if (nameTrigger) {
  openTriggers.push(nameTrigger);
}
let editPackTriggers = document.querySelectorAll('.edit-pack-button');
if (editPackTriggers.length > 0) {
  editPackTriggers.forEach((trigger) => {
    openTriggers.push(trigger);
  });
}
let packTriggers = document.querySelectorAll('.show-pack-drawer');
if (packTriggers.length > 0) {
  packTriggers.forEach((trigger) => {
    openTriggers.push(trigger);
  });
}

// Buttons
let selectBtn = document.getElementById('select-pet');
let formEl = selectModal.querySelector('form');

// Reset new pet form
function resetForm() {
  const infoModalList = document.getElementById('dogInfoModalList');
  if (infoModalList) {
    infoModalList.classList.remove('modal-open');
  }

  formEl.id = 'create-pet';
  formEl.reset();

  const petWeightInput = formEl.querySelector('input[name="pet-weight"]');
  const petBreedInput = formEl.querySelector('input[name="pet-breed"]');
  const petAgeInput = formEl.querySelector('input[name="pet-age"]');
  const defaultBreedOption = formEl.querySelector(
    '.pet-breed-input .select-option:first-child'
  );
  const defaultAgeOption = formEl.querySelector(
    '#dog-age-container .select-option:first-child'
  );

  petWeightInput.value = 5;
  petWeightInput.dispatchEvent(new Event('input'));

  if (defaultBreedOption) {
    petBreedInput.value = defaultBreedOption.dataset.value;
    petBreedInput.dispatchEvent(new Event('input'));
  }

  if (defaultAgeOption) {
    petAgeInput.value = defaultAgeOption.dataset.value;
    petAgeInput.dispatchEvent(new Event('input'));
  }

  modalContentWrapper.scrollTo({ top: 0, behavior: 'instant' });
}

function onOpenCreateModal() {
  const buttonEls = document.querySelectorAll(
    'button[data-modal-target="dogBuilderModal"]'
  );

  buttonEls.forEach((buttonEl) => {
    buttonEl.addEventListener('click', () => resetForm());
  });
}

// If customer and on account page add event listeners for edit buttons
function initPageEdits() {
  if (!customerId) return;
  document.querySelectorAll('.account--edit-pet').forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      showDrawer();
      let id = this.getAttribute('data-edit-pet');
      let target = selectModal.querySelector(
        `.pet-selector[data-pet-id="${id}"] .pet-edit-button`
      );
      target.click();
    });
  });
}
initPageEdits();

// Open drawer
function showDrawer() {
  selectModal.classList.add('show-init', 'show-tip');
  html.classList.add('js-drawer-open', 'lock-scroll');
  const options = selectModal.querySelectorAll(
    '.pet-name-option:not(.placeholder-option)'
  );
}

// Delete pets actions
function deletePet() {
  const deleteButtonEl = selectModal.querySelector(
    '[data-action="form-edit-delete"]'
  );

  deleteButtonEl.addEventListener('click', function (e) {
    e.preventDefault();
    modalContentWrapper.scrollTo({ top: 0, behavior: 'instant' });
    modalContentWrapper.classList.add('lock-scroll');
    deleteConfirmPanel.classList.add('modal-open');
    deleteConfirmPanel.classList.remove('hidden');
    // Ensuring event handlers are not repeatedly attached
    const confirmDeletion = deleteConfirmPanel.querySelector('#delete-confirm');
    const cancelDeletion = deleteConfirmPanel.querySelector('#delete-cancel');
    // Using a one-time event listener to avoid multiple bindings
    confirmDeletion.onclick = function () {
      performDeletion(deleteButtonEl);
      modalContentWrapper.classList.remove('lock-scroll');
    };
    cancelDeletion.onclick = function () {
      deleteConfirmPanel.classList.remove('modal-open');
      modalContentWrapper.classList.remove('lock-scroll');
    };
  });
}

function performDeletion(deleteButton) {
  let optionId = deleteButton.closest('form').id.replace('edit-', '');
  updateLocalStorage(optionId);

  deleteConfirmPanel.classList.remove('modal-open');
  document.dispatchEvent(new Event('petSelection:delete'));
  document.dispatchEvent(
    new CustomEvent('closeModal', {
      detail: {
        target: 'dogBuilderModal'
      }
    })
  );
}

function updateLocalStorage(optionId) {
  let originalPetJson = JSON.parse(
    localStorage.getItem('petProfiles') || '{"pets":[]}'
  );
  let updatedPetList = originalPetJson.pets.filter(
    (pet) => pet.id !== optionId
  );
  localStorage.setItem('petProfiles', JSON.stringify({
    email: originalPetJson.email || '',
    pets: updatedPetList
  }));
}

// Unique ID generator
function createId() {
  let result = '';
  let characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for (var i = 0; i < 8; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// show meal plan modal
function openMealPlanModal(petName) {
  document
    .querySelectorAll('.js-meal-plan-dog')
    .forEach((el) => (el.textContent = petName));

  document.dispatchEvent(
    new CustomEvent('closeModal', {
      detail: {
        target: 'dogBuilderModal'
      }
    })
  );

  document.dispatchEvent(
    new CustomEvent('openModal', {
      detail: {
        target: 'dogMealPlanModal'
      }
    })
  );
}

// Save buttons
function saveActions() {
  let saveButtons = document.querySelectorAll('[data-action="form-save"]');
  saveButtons.forEach((saveButton) => {
    let wrap;
    saveButton.addEventListener('click', function (e) {
      e.preventDefault();
      let form = saveButton.closest('form');
      // Get error elements by their parent input
      let nameInput = form.querySelector('[name="pet-name"]');
      let breedInput = form.querySelector('[name="pet-breed"]');
      let emailInput = form.querySelector('[name="pet-owner-email"]');

      let nameError = nameInput.parentElement.querySelector('.add-error-message');
      let breedError = breedInput.closest('.search-wrap').querySelector('.add-error-message');
      let emailError = emailInput.parentElement.querySelector('.add-error-message');

      // Hide error messages
      if (nameError) nameError.classList.remove('input-error');
      if (breedError) breedError.classList.remove('input-error');
      if (emailError) emailError.classList.remove('input-error');

      // Validate form
      let petName = nameInput.value;
      let petBreed = breedInput.value;
      let petEmail = emailInput.value;

      if (!petName) {
        if (nameError) nameError.classList.add('input-error');
        return;
      }
      if (!breedOptions.includes(petBreed)) {
        if (breedError) breedError.classList.add('input-error');
        return;
      }
      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!petEmail || !emailRegex.test(petEmail)) {
        if (emailError) emailError.classList.add('input-error');
        return;
      }
      if (petName && breedOptions.includes(petBreed)) {
        let petActivity = form.querySelector(
          '[name="activity-level"]:checked'
        ).value;
        let bodyType = form.querySelector('input[name="body-type"]:checked');
        let petWeight = form.querySelector('input[name="pet-weight"]').value;
        let petBodyType = bodyType ? bodyType.value : null;
        let petAge = form.querySelector('#dog-age')
          ? form.querySelector('#dog-age').value
          : 1;
        let petSexInput = form.querySelector('[name="pet-sex"]:checked');
        let petSex = petSexInput ? petSexInput.value : null;

        // Local storage updates
        let petsArray = [];
        let existingPets = JSON.parse(localStorage.getItem('petProfiles'));
        let editId;
        if (existingPets) {
          if (form.id !== 'create-pet') {
            editId = form.id;
            editId = editId.replace('edit-', '');
          }
          petsArray = existingPets.pets;
        }
        let uniqueId = editId ? editId : createId();
        let newProfile = true;
        const newPetProfile = {
          id: uniqueId,
          name: petName,
          breed: petBreed,
          weight: petWeight,
          age: petAge,
          bodyType: petBodyType,
          activity: petActivity ? petActivity : null,
          sex: petSex
        };

        if (editId) {
          let matchedPet = petsArray.find((pet) => pet.id === editId);
          newProfile = matchedPet ? false : true;
          if (matchedPet) {
            matchedPet.name = petName;
            matchedPet.breed = petBreed;
            matchedPet.weight = petWeight;
            matchedPet.age = petAge;
            matchedPet.bodyType = petBodyType;
            matchedPet.activity = petActivity ? petActivity : null;
          }
        }
        if (newProfile) {
          petsArray.push(newPetProfile);
        }
        // Store email globally (shared across all pets)
        let profileJson = {
          email: petEmail,
          pets: petsArray
        };
        let profileData = JSON.stringify(profileJson);
        localStorage.setItem('petProfiles', profileData);
        localStorage.setItem('selectedPet', uniqueId);

        // Send to Klaviyo
        if (typeof klaviyo !== 'undefined') {
          try {
            // Build Klaviyo profile with all pet data
            let klaviyoProfile = {
              'email': petEmail,
              'Pet_Count': petsArray.length,
              'Pet_Names': petsArray.map(p => p.name)
            };

            // Add individual pet properties (Pet_1_Name, Pet_2_Name, etc.)
            petsArray.forEach((pet, index) => {
              let petNum = index + 1;
              klaviyoProfile[`Pet_${petNum}_Name`] = pet.name;
              klaviyoProfile[`Pet_${petNum}_Breed`] = pet.breed;
              klaviyoProfile[`Pet_${petNum}_Weight`] = pet.weight;
              klaviyoProfile[`Pet_${petNum}_Age`] = pet.age;
              klaviyoProfile[`Pet_${petNum}_Body_Type`] = pet.bodyType;
              klaviyoProfile[`Pet_${petNum}_Activity`] = pet.activity;
            });

            // Identify user in Klaviyo
            klaviyo.identify(klaviyoProfile);
          } catch (error) {
            console.error('Klaviyo identify error:', error);
          }
        }

        // If customer is logged in and on the account page update display components
        if (customerId && form.id !== 'create-pet') {
          let query = '.account--pet-item-wrap[data-pet-id="' + uniqueId + '"]';
          let panelDisplayObj = document.querySelector(query);
          if (panelDisplayObj) {
            let pageWeight = panelDisplayObj.querySelector(
              '.account-weight-display'
            );
            pageWeight.textContent = petWeight;
            pageName.textContent = petName;

            let pageAge = panelDisplayObj.querySelector('.account-age-display');
            let pageAgeType =
              panelDisplayObj.querySelector('.account-age-value');
            let ageYears;
            let ageMonths;
            if (petAge.includes(', ')) {
              let ageSplit = petAge.split(', ');
              ageYears = ageSplit[0];
              ageYears = ageYears.split(' ');
              ageYears = parseInt(ageYears[0]);
              ageMonths = ageSplit[1];
              ageMonths = ageMonths.split(' ');
              ageMonths = parseInt(ageMonths[0]);
            } else {
              if (petAge.includes('year') || petAge.includes('years')) {
                ageYears = petAge.split(' ');
                ageYears = parseInt(ageYears[0]);
                ageMonths = 0;
              } else {
                ageMonths = petAge.split(' ');
                ageMonths = parseInt(ageMonths[0]);
                ageYears = 0;
              }
            }
            if (ageYears !== 0) {
              let monthsDecimal;
              if (ageMonths > 2 && ageMonths < 5) {
                monthsDecimal = '.25';
              } else if (ageMonths >= 5 && ageMonths < 8) {
                monthsDecimal = '.5';
              } else if (ageMonths >= 8) {
                monthsDecimal = '.75';
              }
              let pageAgeDisplay = ageYears + monthsDecimal;
              pageAge.textContent = pageAgeDisplay;
              if (pageAgeDisplay == '1') {
                pageAgeType.textContent = 'year old';
              } else {
                pageAgeType.textContent = 'years old';
              }
            } else {
              pageAge.textContent = ageMonths;
              if (ageMonths == '1') {
                pageAgeType.textContent = 'month old';
              } else {
                pageAgeType.textContent = 'months old';
              }
            }
          }
        } else if (customerId && form.id === 'create-pet') {
          let panelCloneItem = document.querySelector(
            '.account--pet-placeholder'
          );
          if (panelCloneItem) {
            let newItem = panelCloneItem.cloneNode(true);
            newItem.classList.remove('hidden');
            newItem.classList.remove('account--pet-placeholder');
            newItem.setAttribute('data-pet-id', uniqueId);
            let newName = newItem.querySelector('.account-name-display');
            newName.textContent = petName;
            // let newBreed = newItem.querySelector('.account-breed-display');
            // newBreed.textContent = petBreed;
            let newEdit = newItem.querySelector('.account--edit-pet');
            newEdit.setAttribute('data-edit-pet', uniqueId);
            let newWeight = newItem.querySelector('.account-weight-display');
            newWeight.textContent = petWeight;

            let newParent = panelCloneItem.closest('.address-grid-wrap');
            newParent.classList.remove('mb0');
            newParent.appendChild(newItem);

            initPageEdits();
          }
        }
        if (form.id === 'create-pet') {
          let petAdded = new CustomEvent('petSelection:add', {
            detail: newPetProfile
          });
          document.dispatchEvent(petAdded);
        } else {
          let petEdited = new CustomEvent('petSelection:edit', {
            detail: newPetProfile
          });
          document.dispatchEvent(petEdited);
        }
      }
      profileSync();
      saveAndClose(petName);
      const dropdownToggle = document.querySelector('[data-dropdown-toggle]');
      if (dropdownToggle) dropdownToggle.click();
    });
  });
}

function saveAndClose(petName) {
  const modal = document.querySelector('#dogBuilderModal');

  if (modal && modal.hasAttribute('data-save-only')) {
    document.dispatchEvent(
      new CustomEvent('closeModal', {
        detail: {
          target: 'dogBuilderModal'
        }
      })
    );
    return;
  }

  openMealPlanModal(petName);
}
// New Pet Form
let addFormWrap = document.getElementById('add-pet-panel');
let saveNew = document.getElementById('add-new-pet');

if (customerId) {
  let pageAddBtns = document.querySelectorAll(
    '.add-pack-member-button, [data-action="add-pet-profile"]'
  );
  pageAddBtns.forEach((button) => {
    button.addEventListener('click', function () {
      showDrawer();
      addBtn.click();
    });
  });
}

// --------------------------------------------------------------------

// Predictive search functionality

// --------------------------------------------------------------------

let placeholderWrap = document.getElementById('list-template');
let placeholderTemp = placeholderWrap.querySelector('li');
let placeholder = placeholderTemp.cloneNode(true);
placeholderWrap.remove();

function updateResults(input) {
  let parent = this.closest('.search-wrap');
  let query = this.value.toLowerCase();
  let options = parent.querySelectorAll('.autofill-list-item');
  // Add matching values
  for (let i = 0; i < options.length; i++) {
    let option = options[i];
    let optionValue = option.querySelector('input').value.toLowerCase();
    if (optionValue.includes(query)) {
      option.classList.remove('hidden');
    } else {
      option.classList.add('hidden');
    }
  }
}

function fillResult() {
  let listItems = document.querySelectorAll('.breed-list-item');
  for (let i = 0; i < listItems.length; i++) {
    let item = listItems[i];
    let option = item.querySelector('label');
    let outer = option.closest('.search-wrap');
    let searchBox = outer.querySelector('.search-input');
    option.addEventListener('mousedown', function () {
      searchBox.value = option.textContent;
      let autofillBreed = new Event('fill-select');
      document.dispatchEvent(autofillBreed);
    });
  }
}

function checkResult(input) {
  let searchBox = this.closest('.search-wrap');
  let value = this.value;
  let resultError = searchBox.querySelector('.add-error-message');
  if (!breedOptions.includes(value)) {
    resultError.classList.add('input-error');
  } else {
    resultError.classList.remove('input-error');
  }
  searchBox.dispatchEvent(new Event('breed:selection'));
}

// --------------------------------------------------------------------

// Get & set savedPets from local storage data

// --------------------------------------------------------------------

let savedPets = JSON.parse(localStorage.getItem('petProfiles'));

// Metafield pets defined in theme.liquid header (for easy liquid access)
function setLocalToMeta() {
  let localPush = {};
  if (metafieldPets.length > 0) {
    localPush.pets = metafieldPets;
    localPush = JSON.stringify(localPush);
    localStorage.setItem('petProfiles', localPush);
    savedPets = JSON.parse(localStorage.getItem('petProfiles'));
  }
}

if (savedPets && metafieldPets) {
  if (savedPets.pets !== metafieldPets) {
    setLocalToMeta();
  }
}

// If local storage does not have savedPets but metafields do
if (metafieldPets && !savedPets) {
  setLocalToMeta();
}

// Open triggers event listener
openTriggers.forEach((trigger) => {
  trigger.addEventListener('click', showDrawer);
});

let emailForms = [];

// Find all forms on page and add event listener to forms with email field
let forms = document.querySelectorAll('form');
for (let i = 0; i < forms.length; i++) {
  let form = forms[i];
  let ignoreForms = ['customer_login', 'customer_recover'];
  let emailInput = form.querySelector('input[type="email"]');
  if (!ignoreForms.includes(form.id) && emailInput) {
    emailForms.push(form);
  }
}

emailForms.forEach((form) => {
  form.addEventListener('submit', function () {
    window.onbeforeunload(function () {
      localStorage.setItem('profileSyncPending', 'true');
    });
  });
});

function clearStoredProfile() {
  localStorage.removeItem('petProfiles');
  localStorage.removeItem('selectedPet');
}

let logOut = document.getElementById('customer_logout_link');
if (logOut) {
  logOut.addEventListener('click', clearStoredProfile);
}

// Sync local storage pet data to customer metafield: {{ customer.metafields.profile.pets }}
function profileSync() {
  let metafieldContent = JSON.parse(localStorage.getItem('petProfiles'));
  metafieldContent = metafieldContent.pets;
  localStorage.setItem('customerCartSync', 'true');
  localStorage.setItem(
    'customerCartSyncAttributes',
    JSON.stringify(metafieldContent)
  );
  handleCartSync({ pet_profiles: metafieldContent });
  console.log('Syncing profile data to metafield then customerId');
  if (customerId) {
    metafieldContent = JSON.stringify(metafieldContent);

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let body = {
      customerID: customerId,
      metafieldContent: metafieldContent
    };

    const options = {
      method: 'POST',
      headers,
      mode: 'cors',
      body: JSON.stringify(body)
    };

    fetch('https://enu31tivv8qflp8.m.pipedream.net', options).then(
      function (response) {
        if (response.status === 400) {
          console.log('There was an error updating your profile.');
        }
      }
    );
  }
}

let initialSync = localStorage.getItem('profileSyncPending');
if (initialSync === 'true') {
  if (!metafieldPets) {
    profileSync();
  }
  localStorage.removeItem('profileSyncPending');
}

let accountIcons = document.querySelectorAll('.account-icon');
accountIcons.forEach((icon) => {
  icon.addEventListener('click', function () {
    icon.classList.toggle('show-actions');
    window.addEventListener('scroll', function () {
      icon.classList.remove('show-actions');
    });
  });
});

// Highlight table stuff

document.addEventListener('DOMContentLoaded', function () {
  let tableWrappers = document.querySelectorAll('.options-table-shell');
  tableWrappers.forEach((table) => {
    let adultToggle = table.querySelector('.option-category-adult');
    let puppyToggle = table.querySelector('.option-category-puppy');

    function toggleHighlight() {
      adultToggle.classList.remove('toggle-selected');
      if (puppyToggle) {
        puppyToggle.classList.remove('toggle-selected');
      }
      let cells = table.querySelectorAll('td, th');
      cells.forEach((cell) => {
        cell.classList.remove('highlight-basic');
      });
      let rows = table.querySelectorAll('tr, thead');
      this.classList.add('toggle-selected');
      rows.forEach((row) => {
        let cells = row.querySelectorAll('td, th');
        for (let i = 0; i < cells.length; i++) {
          if (this === adultToggle) {
            if (i === 1 || i === 2) {
              cells[i].classList.add('highlight-basic');
            }
          } else {
            if (i === 3 || i === 4) {
              cells[i].classList.add('highlight-basic');
            }
          }
        }
      });
    }

    if (adultToggle) {
      adultToggle.addEventListener('click', toggleHighlight);
    }
    if (puppyToggle) {
      puppyToggle.addEventListener('click', toggleHighlight);
    }
  });
});

function initModalOptions() {
  initBreedDropdown();
  saveActions();
  deletePet();
  onOpenCreateModal();
}

document.addEventListener('DOMContentLoaded', initModalOptions);
